import React, { Component } from "react";
import { connect } from "react-redux";
import WorkHistory from "../components/WorkHistory";
import {
  searchCompanies,
  createCompany,
  fetchCompanies
} from "../../../../actions/company.actions";
import { updateUserData } from "../../../../actions/user.actions";

class WorkHistoryContainer extends Component {
  constructor(props) {
    super(props);
    this.memberId = this.props.match.params.memberId;
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.fetchCompanies();
  }

  handleSubmit(data) {
    if (!this.memberId) {
      this.props.updateUserData(data, "/member/profile", "workHistory");
    } else {
      const url = /(5|6|7|9)/.test(this.props.user.status_id)
        ? `/admin/member/${this.memberId}/moderation`
        : `/admin/member/approved/${this.memberId}/profile`;

      this.props.updateUserData(data, url, "workHistory");
    }
  }

  render() {
    return (
      <WorkHistory
        onSubmit={this.handleSubmit}
        companies={this.props.companies}
        createCompany={this.props.createCompany}
        isLoadingCompany={this.props.isLoadingCompany}
        onSearchCompanies={this.props.searchCompanies}
        memberId={this.memberId}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    companies: state.company.companies.data,
    isLoadingCompany: state.company.isLoading,
    user: state.user.data
  };
};

const mapDispatchToProps = dispatch => ({
  fetchCompanies: () => dispatch(fetchCompanies()),
  createCompany: company => dispatch(createCompany(company)),
  searchCompanies: query => dispatch(searchCompanies(query)),
  updateUserData: (user, redirect, formName) =>
    dispatch(updateUserData(user, redirect, formName))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WorkHistoryContainer);



// WEBPACK FOOTER //
// ./src/routes/candidate/profile/containers/WorkHistoryContainer.js